import angular from 'angular';

import GridComponent from './grid-component';
import PaginationComponent from './pagination-component';
import TableComponent from './table-component';
import MobileSortComponent from './mobile-sort-component';
import TableService from './table-service';
import TableColumnComponent from './table-column-component';
import { TableColumnController } from './table-column-controller';
import TableCellComponent from './table-cell-component';

export default angular
  .module('grid', [])
  .controller('TableColumnController', TableColumnController)
  .component('grid', new GridComponent())
  .component('pagination', new PaginationComponent())
  .component('rwTable', new TableComponent())
  .component('rwTableColumn', TableColumnComponent)
  .component('rwTableCell', TableCellComponent)
  .component('mobileSort', new MobileSortComponent())
  .service('tableService', TableService);



// WEBPACK FOOTER //
// ./src/modules/utils/grid/grid-module.js